// extracted by mini-css-extract-plugin
module.exports = {"scanToDownloadContainer":"ScanToDownloadCTABanner_scanToDownloadContainer__tDJqk","qrCodeContainer":"ScanToDownloadCTABanner_qrCodeContainer__uyVi2"};